import { render } from "./Section-2.1.vue?vue&type=template&id=24f58332&scoped=true"
import script from "./Section-2.1.vue?vue&type=script&lang=js"
export * from "./Section-2.1.vue?vue&type=script&lang=js"

import "./Section-2.1.vue?vue&type=style&index=0&id=24f58332&scoped=true&lang=css"

import exportComponent from "C:\\Spinnov\\ace-challenge-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f58332"]])

export default __exports__